
import { Action             } from "@/models/action";
import { ActionType         } from "@/models/action.type";
import { Logger             } from "@/util/logger";
import { PanoramaController } from "@/components/panorama.controller";

export class FullscreenToggleAction extends Action {

  /** the panoramic controller that can actually do stuff for us */
  private _controller : PanoramaController = null;

  /** standard constructor */
  constructor(controller : PanoramaController) {
    super({
      key:   ActionType.PANO_TOGGLE_FULLSCREEN,
      type:  ActionType.PANO_TOGGLE_FULLSCREEN,
      label: 'Toggle Fullscreen',
      icon:  '',
      tip:   ''
    });

    this._controller = controller;
  }

  /** fetch the panoramic controller */
  public controller(): PanoramaController {

    return this._controller;
  }

  /** implement the action */
  public execute() : boolean {

    this._controller.toggleFullscreen();

    return true;
  }
}
